import { inject, signal, Signal } from '@angular/core';
import { injectQuery, QueryClient } from '@tanstack/angular-query-experimental';

import { GqlService, OrganizationType } from '@shared/services/gql.service';
import { MainQuery } from '@shared/store/main/main.query';
import { gqlToPromise } from '@shared/utils/gql-to-promise';
import { Utils } from '@shared/utils/utils';

export const injectListOrganizationsWithTotalsQuery = ({
  enabled = signal(false),
  includeInactive = signal(false),
}: {
  enabled?: Signal<boolean>;
  includeInactive?: Signal<boolean>;
} = {}) => {
  const gqlService = inject(GqlService);
  const mainQuery = inject(MainQuery);

  return injectQuery(() => ({
    enabled: enabled(),
    queryFn: async () => {
      const result = await gqlToPromise(() => {
        return gqlService.listOrganizationsWithTotalBudgetAmount$(includeInactive());
      });

      return (result || [])
        .filter((org) => org.organization_type === OrganizationType.ORGANIZATION_VENDOR)
        .sort((a, b) => Utils.alphaNumSort(a.name, b.name));
    },
    queryKey: [
      'trials',
      'detail',
      mainQuery.trialKey(),
      'list-organizations-with-totals',
      { includeInactive: includeInactive() },
    ],
  }));
};

export const injectRefetchListOrganizationsWithTotalsQuery = () => {
  const queryClient = inject(QueryClient);

  return () => {
    void queryClient.invalidateQueries({
      queryKey: ['list-organizations-with-totals'],
    });
  };
};
